<template>
    <v-container>
        <v-card class="dt-border pad-10" flat>
            <div class="pa-5 mb-5">
                <h2>PIN</h2>
                <p class="mb-0">*Enter your 4 to 8 Digits PIN*</p>
            </div>
            <v-row>
                <v-col cols="12" md="8">
                    <v-form class="pl-5 pr-5 mb-5" ref="form">
                        <label for="">Enter Old PIN</label>
                        <v-text-field  inputmode="numeric" ref="pinInput" @keypress="validateNumeric" @paste="onPaste" v-model="password" maxlength="8" minlength="4"
                            :rules="passwordRules" :type="show ? 'number' : 'password'" class="pass-input"
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" @click:append="show = !show" required
                            color="auto" outlined pattern="[0-9]*"></v-text-field>
                        <label for="">Enter New PIN</label>
                        <v-text-field inputmode="numeric" ref="pinInput" @keypress="validateNumeric" @paste="onPaste" maxlength="8" minlength="4" :type="show1 ? 'number' : 'password'"
                            class="pass-input" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="show1 = !show1" v-model="newpassword" :rules="newpasswordRules" required
                            color="auto" outlined pattern="\d*"></v-text-field>
                        <label for="">Confirm PIN</label>
                        <v-text-field inputmode="numeric" ref="pinInput" @keypress="validateNumeric" @paste="onPaste" maxlength="8" minlength="4"
                         :type="show1 ? 'number' : 'password'" :rules="cnewpasswordRules.concat(passwordConfirmationRule)"
                            class="pass-input" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="show2 = !show2"   v-model="cnewpassword"  required
                            color="auto" outlined pattern="\d*"></v-text-field>
                      
                        <br>
                        <default-button :loading="loading" :disabled="!isComplete" @click="validateForm">Change
                            Pin</default-button>
                    </v-form>

                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
// ============= IMPORT COMPONENTS ===========
import DefaultButton from "@/components/Buttons/default-button.vue";
// ========== IMPORT SERVICES =========
import { AdminService } from "@/services";

export default {
    data: () => ({
        password: '',
        show1: true,
        show: true,
        show2: true,
        newpassword: '',
        cnewpassword: '',
        loading: false,
        passwordRules: [
            (v) => !!v || "This field is required",
            (v) =>
                /^\d{4,8}$/.test(v) || "PIN must contain 4 to 8 digits",
        ],
        newpasswordRules: [
            (v) => !!v || "This field is required",
            (v) =>
                /^\d{4,8}$/.test(v) || "PIN must contain 4 to 8 digits",
        ],
        cnewpasswordRules: [
            (v) => !!v || "This field is required",
            (v) =>
                /^\d{4,8}$/.test(v) || "PIN must contain 4 to 8 digits",
        ]


    }),
    components: {
        DefaultButton,
    },
    computed: {
        isComplete() {
            return this.password && this.newpassword && this.cnewpassword
        },
        passwordConfirmationRule() {
            return () => this.newpassword === this.cnewpassword || "Password must match";
        }
    },
    methods: {
        validateNumeric(event) {
            const keyCode = event.keyCode ? event.keyCode : event.which;
            const input = this.$refs.pinInput.$refs.input;
            if (keyCode < 48 || keyCode > 57) {
                event.preventDefault();
            }
            if (input.value.length >= 8) {
                event.preventDefault();
            }
        },
        onPaste(event) {
            const input = this.$refs.pinInput.$refs.input;
            const clipboardData = event.clipboardData || window.clipboardData;
            const pastedData = clipboardData.getData("text/plain");
            if (/^\d*$/.test(pastedData) && pastedData.length <= 8 - input.value.length) {
                return true;
            }
            event.preventDefault();
        },
        validateForm() {
            if (this.$refs.form.validate()) {
                this.changePassword();
            }
        },
        async changePassword() {
            try {
                this.loading = true
                let payload = {
                    password: this.password,
                    newpassword: this.newpassword,
                    cnewpassword: this.cnewpassword
                }
                const data = await AdminService.changePin(payload);
                this.$store.dispatch("toast", {
                    message: data.message,
                    variant: "success",
                });
                this.newpassword = '';
                this.cnewpassword = '';
                this.password = '';
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error);
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>